/*
 * Copyright (c) Dito Technologies
 */

import React from "react";
import {createFragmentContainer} from "react-relay";
import {graphql} from "babel-plugin-relay/macro";
import {LibraryRows_musicViewer$data} from "./__generated__/LibraryRows_musicViewer.graphql"
import LibraryRow from "ui/feature/library/LibraryRow";
import styles from "./LibraryRows.module.scss";

interface Props {
    musicViewer: LibraryRows_musicViewer$data;
}

const LibraryRows: React.FC<Props> = ({musicViewer}) => {
    return (
        <div className={styles.container}>
            {musicViewer.pieces.map((piece) => <LibraryRow piece={piece} key={piece.id}/>)}
        </div>
    );
}

export default createFragmentContainer(LibraryRows,
    {
        musicViewer: graphql`
        fragment LibraryRows_musicViewer on MusicViewer {
            pieces {
                id
                ...LibraryRow_piece
            }
        }
        `
    }
);